
import { IntroAction, IntroActionType } from '../_actions/IntroActions';
import IntroStore from '../_stores/IntroStore';

const IntroReducer = (store:IntroStore = new IntroStore(), action: IntroAction):IntroStore => {
	switch (action.type) {
		case IntroActionType.OnIntroOpen:
			return store.set('opened', action.value);
	}
	
	// Intended unreachable code
	return store;
}

export default IntroReducer